


































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Popup } from '@questelservices/common-vue';
import { DxEditing, DxColumn, DxDataGrid, DxPager, DxPaging, DxRemoteOperations, DxFilterRow, DxHeaderFilter, DxSelection } from 'devextreme-vue/data-grid';
import { DxButton, DxCheckBox, DxTextBox, DxSelectBox, DxLoadPanel, DxTagBox } from 'devextreme-vue';
import { DxValidator, DxCustomRule, DxRequiredRule } from 'devextreme-vue/validator';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import DataSource from "devextreme/data/data_source";
import { QuestelServicesClient, HttpMethodEnum, RequestResult } from '@questelservices/common';
import { ClientAgentService } from '../../service/ClientAgentService';
import { Prop } from 'vue-property-decorator';    
import notify from 'devextreme/ui/notify';
import { confirm, alert } from 'devextreme/ui/dialog';    
import { ClientAgentJurisdictionDto } from '../../models/client-agent/ClientAgentJurisdictionDto';
import { AgentService } from '../../service/AgentService';    
import { ClientAgentInfoDto } from '../../models/client-agent/ClientAgentInfoDto';    
import { CountryDto } from '../../models/CountryDto';
import DxValidationGroup from 'devextreme-vue/validation-group'
import ValidationGroup from "devextreme/ui/validation_group";
import _ from 'lodash';
import { AuditingService } from '../../service/AuditingService';

@Component({
    components: {
        DxDataGrid,
        DxEditing,
        DxCheckBox,
        DxPager,
        DxPaging,
        DxRemoteOperations,
        DxFilterRow,
        DxColumn,
        DxButton,
        DxTextBox,
        DxHeaderFilter,
        DxSelection,
        Popup,
        DxToolbarItem,
        DxSelectBox,
        DxLoadPanel,
        DxValidator,
        DxCustomRule,
        DxScrollView,
        DxTagBox,
        DxValidationGroup,
        DxRequiredRule
    }
})
export default class AgentInfoEdit extends Vue {
    public $refs: Vue['$refs'] & {
        jurisdictionDatagrid?: DxDataGrid;  
        validationGroupRef? : ValidationGroup;
    } = {};

    private readonly emailSeparator: string = ';';
    
    @Prop({ default: false })
    showDialog!: boolean;        

    @Prop()
    clientAgentInfoDto!: ClientAgentInfoDto;

    clientAgentInfo: ClientAgentInfoDto = new ClientAgentInfoDto();
    mainEmailSource: string[] = [""];
    emailCCSource: string[] = [""];
    selectedEmailCC: string[] = [];
    selectedMainEmail: string[] = [];
    origUnsetCountries: CountryDto[] = [];
    loadingExistingSettings: boolean = false;
    private agentObj: ClientAgentInfoDto | null = null;

    agents: Array<string> = [];
    get agentsDataSource() : DataSource {
      return new DataSource({
        store: this.agents,
        paginate: true,
        pageSize: 100
      });
    }

    private get validationGroup() {
        return ((this.$refs.validationGroupRef as ValidationGroup).instance as any); 
    }

    clientAgentService: ClientAgentService;
    private client = new QuestelServicesClient(this.$store, '');
    private submittingFileParseUpload: boolean = false;
    auditingService: AuditingService;        
            
    jurisdictionDataSource: Array<{
        ClientAgentJurisdictionId: Guid;
        Country: CountryDto;
        InJurisdiction: boolean;
        OutJurisdiction: boolean;
    }> = [];

    readonly emptyGuid: string = "00000000-0000-0000-0000-000000000000";
    validationRule = {
        invalidEmail : {
            type: 'email',
            message : 'Invalid email'
        },
        noError : {}
    }

    //primaryAgentName: string = this.agentInfoData.AgentName;
    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value) {              
        this.$emit("hiding", this.agentObj);
    }

    @Watch("showDialog")
    onPropertyChanged(value: boolean, oldValue: boolean) {               
        if (value) {
            if(this.$refs.jurisdictionDatagrid && this.$refs.jurisdictionDatagrid.instance) {
                this.$refs.jurisdictionDatagrid.instance.clearFilter();
            }                
            this.clientAgentInfo = _.cloneDeep(this.clientAgentInfoDto); 
            if (this.clientAgentInfo.PrimaryAlias.AgentAlias == "") {
                this.clientAgentInfo.PrimaryAlias.AgentAlias = this.clientAgentInfo.Agent.AgentName;
            }

            this.setMainEmail(this.clientAgentInfo.AgentEmail);
            this.setEmailCC(this.clientAgentInfo.AgentCCEmail);
            this.origUnsetCountries = this.clientAgentInfoDto.UnsetCountries;
            if(this.clientAgentInfo.IsUnrecognizedAgent) {
                this.checkForExistingAlias()
                    .then(result => {                             
                        if(result.ClientAgentId != 0) {                                
                            var dialogResult = confirm(`This agent alias exists for agent ${result.Agent.AgentName}
                                and client ${result.Client.ClientName}. Would you like to load the existing agent settings?`, "Existing Alias");
                            dialogResult
                            .then(dialogResult => {
                                if(dialogResult) {
                                    this.loadingExistingSettings = true;                                        
                                    this.clientAgentInfo.Agent = result.Agent; 
                                    this.clientAgentInfo.JurisdictionFree = result.JurisdictionFree;
                                    this.clientAgentInfo.Jurisdictions = result.Jurisdictions;
                                    this.clientAgentInfo.VendorNumber = result.VendorNumber;

                                    // Get all unset countries that are not already in Jurisdictions
                                    let setCountries = this.clientAgentInfo.Jurisdictions.map(j => j.Country.CountryCode);
                                    this.clientAgentInfo.UnsetCountries = this.getUnsetCountries(setCountries, result.UnsetCountries);

                                    this.clientAgentInfo.AgentEmail = result.AgentEmail;
                                    this.clientAgentInfo.AgentCCEmail = result.AgentCCEmail;
                                    
                                    this.setMainEmail(this.clientAgentInfo.AgentEmail);
                                    this.setEmailCC(this.clientAgentInfo.AgentCCEmail);
                                }
                                this.displayJurisdictions();
                            });
                        }                            
                        else {
                            this.displayJurisdictions();
                        }
                    });
            }
            else {
                this.displayJurisdictions(); 
            }              
        }            
    }   

    setMainEmail(mainEmail: any) {
        this.mainEmailSource = mainEmail ? mainEmail.split(this.emailSeparator) : [''];
        this.selectedMainEmail = mainEmail ? mainEmail.split(this.emailSeparator) : [];
    }
    setEmailCC(emailCC: any) {
        this.emailCCSource = emailCC ? emailCC.split(this.emailSeparator) : [''];;
        this.selectedEmailCC = emailCC ? emailCC.split(this.emailSeparator) : [];
    }

    constructor() {
        super();               
        this.clientAgentService = new ClientAgentService();
        this.auditingService = new AuditingService();   
        this.loadData();       
    }        

    async loadData() {            
        let agentService = new AgentService();
        let agents = await agentService.getAll();
        this.agents = agents.map(a => {
            return a.AgentName;
        });
    }

    async checkForExistingAlias(): Promise<ClientAgentInfoDto> {
        return await this.clientAgentService
            .getExistingClientAgentDataByAlias(this.clientAgentInfo.PrimaryAlias.AgentAlias);
    }

    checkEmailValidation(text: string) {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(text)
    }
  
    
    duplicateCustomItem: string = ""
    onCustomItemCreatingEvent(e:any) {
        if (this.checkEmailValidation(e.text))
        {
            let name = e.component.option("name");
            if(name == "emailCCComponent")
            {
                if(_.find(this.emailCCSource, item => item === e.text)) {
                    this.duplicateCustomItem = e.text;
                }
                else {
                    this.emailCCSource.push(e.text);
                }
            }
            else {
                if(_.find(this.mainEmailSource, item => item === e.text)) {
                    this.duplicateCustomItem = e.text;
                }
                else {
                    this.mainEmailSource.push(e.text);
                }
            }
        }
        else {
            e.component.option("isValid", false)
            e.component.option("validationError",this.validationRule.invalidEmail)
        }
    }

    onEmailCCValueChanged(e:any) {
        if(this.duplicateCustomItem){
            let val = e.component.option("value");

            val.push(this.duplicateCustomItem);
            e.component.option("value", val);

            this.duplicateCustomItem = "";
        }
        if(e.value && e.value.length > 0) {
            if(_.find(e.value,item => !(this.checkEmailValidation(item)))) {
                e.component.option("isValid", false)
                e.component.option("validationError",this.validationRule.invalidEmail)
            }
            else {
                e.component.option("isValid", true)
                e.component.option("validationError", null)
            }
        }
        else {
                e.component.option("isValid", true)
                e.component.option("validationError", null)
        }
    }

    tagItemStyle(e:any) {
        return {
            'background-color' : this.checkEmailValidation(e) ? '#e0e0e0' : '#f5b5b5'
        }
    }       

    onOpenedEmailCC(e:any) {
        e.component.content().remove();
    }
    
    private async displayJurisdictions() {            

        this.jurisdictionDataSource = []; 
        
        const unsetCountries = await this.clientAgentService.getUnsetCountries(this.clientAgentInfo.Client.ClientId, this.clientAgentInfo.Agent.AgentId);

        for(let country of unsetCountries) {
            this.jurisdictionDataSource.push(
                {
                    ClientAgentJurisdictionId: this.emptyGuid,
                    Country: country,
                    InJurisdiction: false,
                    OutJurisdiction: false
                }
            );
        }
        
        const sortedJurisdiction = _.orderBy(this.clientAgentInfo.Jurisdictions, ['InJurisdiction', 'Country'], ['desc','asc']);

        for(let juris of sortedJurisdiction) {
            this.jurisdictionDataSource.push(
                {
                    ClientAgentJurisdictionId: juris.ClientAgentJurisdictionId,
                    Country: juris.Country,
                    InJurisdiction: juris.InJurisdiction,
                    OutJurisdiction: !juris.InJurisdiction
                }
            );
        }                                                          
    }

    get jurisdictionFree() {
        return this.clientAgentInfo.JurisdictionFree;
    }

    set jurisdictionFree(value: boolean) {
        this.clientAgentInfo.JurisdictionFree = value;             
        if(value) {
            this.jurisdictionDataSource = [];                
        }
        else {
            this.displayJurisdictions();
        }            
    }

    get primaryAgentNameUnset() {
        return this.clientAgentInfo.Agent.AgentName == null
            || this.clientAgentInfo.Agent.AgentName == "";
    }

    displayInJurisdiction(data: any) {
        return data.InJurisdiction;
    }

    displayOutJurisdiction(data: any) {
        return !data.InJurisdiction;
    }

    jurisdictionRadioFunction(e: any) {
        if(e.newData.InJurisdiction && e.oldData.OutJurisdiction) {
            e.newData.OutJurisdiction = false;
        }
        else if(e.newData.OutJurisdiction && e.oldData.InJurisdiction) {
            e.newData.InJurisdiction = false;
        }
    }

    addAgentName(e: any) {      
        e.customItem = e.text;
        if(!this.agents.some(a => a == e.text)) {
            this.agents.push(e.customItem);                 
        }
        this.clientAgentInfo.Agent.AgentName = e.text;
    }

    loadAgentData(e: any) {
        if(this.loadingExistingSettings) {
            this.loadingExistingSettings = false;
            return;
        }

        if(this.showingDialog) {
            if(this.clientAgentInfo.IsUnrecognizedAgent && this.clientAgentInfo.Agent.AgentName != null)
            {
                this.clientAgentService.getExistingClientAgentData(this.clientAgentInfo.Client.ClientId, this.clientAgentInfo.Agent.AgentName)
                .then(result => {
                    if(result.ClientAgentId != 0) {      
                        this.clientAgentInfo.ClientAgentId = this.clientAgentInfo.Client.ClientId == result.Client.ClientId ? result.ClientAgentId : 0;  
                        this.clientAgentInfo.Agent.AgentId = result.Agent.AgentId;                           
                        this.clientAgentInfo.AgentEmail = result.AgentEmail;
                        this.clientAgentInfo.AgentCCEmail = result.AgentCCEmail;
                        this.setMainEmail(this.clientAgentInfo.AgentEmail);
                        this.setEmailCC(this.clientAgentInfo.AgentCCEmail);
                        this.clientAgentInfo.JurisdictionFree = result.JurisdictionFree;
                        this.clientAgentInfo.Jurisdictions = result.Jurisdictions;
                        this.clientAgentInfo.VendorNumber = result.VendorNumber;
                        //Get all unset countries that are not already in Jurisdictions
                        let setCountries = this.clientAgentInfo.Jurisdictions.map(j => j.Country.CountryCode);           
                        this.clientAgentInfo.UnsetCountries = this.getUnsetCountries(setCountries, result.UnsetCountries);                              
                    }                    
                    else if(result.Agent != null) {                            
                        this.clientAgentInfo.Agent.AgentId = result.Agent.AgentId; 
                        this.clientAgentInfo.AgentEmail = "";
                        this.mainEmailSource = [""];
                        this.selectedMainEmail = [];
                        this.clientAgentInfo.AgentCCEmail = '';
                         this.emailCCSource = [""];
                        this.selectedEmailCC = [];
                        this.clientAgentInfo.JurisdictionFree = false;
                        this.clientAgentInfo.Jurisdictions = [];                            
                        this.clientAgentInfo.UnsetCountries = this.origUnsetCountries;
                        this.clientAgentInfo.VendorNumber='';
                    }
                    else {
                        this.clientAgentInfo.AgentEmail = "";
                        this.clientAgentInfo.AgentCCEmail = '';
                        this.clientAgentInfo.JurisdictionFree = false;
                        this.clientAgentInfo.Jurisdictions = [];
                        this.clientAgentInfo.UnsetCountries = this.origUnsetCountries;   
                        this.emailCCSource = [""];
                        this.selectedEmailCC = [];   
                        this.mainEmailSource = [""];
                        this.selectedMainEmail = [];
                        this.clientAgentInfo.VendorNumber='';                       
                    }
                                      
                    this.displayJurisdictions();                  
                });
                
            }
        }            
    }

    hidingEdit() {
        this.clientAgentInfo = new ClientAgentInfoDto();
        this.showingDialog = false;       
    }       

    confirmSave() {            
        let validation = this.validationGroup.validate();
        if(!validation.isValid){
            return;
        }

        if(this.selectedEmailCC && this.selectedEmailCC.length > 0) {
            if(_.find(this.selectedEmailCC, item => !this.checkEmailValidation(item))) {
                return;
            }
        }
        if(this.selectedMainEmail && this.selectedMainEmail.length > 0) {
            if(_.find(this.selectedMainEmail, item => !this.checkEmailValidation(item))) {
                return;
            }
        }

        if (this.clientAgentInfo.PrimaryAlias.AgentAlias.trim() == "") {
            let message = 'Please enter a valid Agent Name for Client.';
            alert(message, 'Error');
            return;
        }
        
        //confirm for creating a new agent
        if(this.clientAgentInfo.Agent.AgentId == this.emptyGuid) {
            var result = confirm(`Are you sure you want to create the new agent 
                ${this.clientAgentInfo.Agent.AgentName}, with the agent alias ${this.clientAgentInfo.PrimaryAlias.AgentAlias} 
                for ${this.clientAgentInfo.Client.ClientName}?`, "New Agent Creation");
            result
            .then(dialogResult => {
                if(dialogResult) {
                    this.saveAgentInfo();
                }
            });
        }
        else {
            this.saveAgentInfo();
        }         
    }

    saveAgentInfo() {            
        let jurisdictions: Array<ClientAgentJurisdictionDto> = [];            
        
        for(let juris of this.jurisdictionDataSource) {                
            if(!juris.InJurisdiction && !juris.OutJurisdiction) {                    
                continue;
            }
            let jursdictionDto: ClientAgentJurisdictionDto = {
                ClientAgentJurisdictionId: juris.ClientAgentJurisdictionId,
                ClientAgentId: this.clientAgentInfo.ClientAgentId,
                Country: juris.Country,
                InJurisdiction: juris.InJurisdiction
            }
            jurisdictions.push(jursdictionDto);
        }

        this.clientAgentInfo.Jurisdictions = jurisdictions;
        this.clientAgentInfo.AgentCCEmail = this.selectedEmailCC && this.selectedEmailCC.length > 0 ?
                                            this.selectedEmailCC.join(this.emailSeparator) : "";
        this.clientAgentInfo.AgentEmail = this.selectedMainEmail && this.selectedMainEmail.length > 0 ?
                                            this.selectedMainEmail.join(this.emailSeparator) : "";            
         
        this.saveClientAgentData()
            .then(async (uploadIds) => {                             
                this.submittingFileParseUpload = true;
                let results: RequestResult<any>[] = [];

                for (let i = 0; i < uploadIds.length; i++) {
                    let uploadId = uploadIds[i];
                    await this.resubmitFileParseUpload(uploadId)
                        .then(result => {
                            results.push(result);
                        })
                        .catch(result => {
                            results.push(result);
                        });
                }

                return results;
            })
            .then(this.handleResubmit)
            .catch(this.handleSaveError)
            .finally(() => {
              this.submittingFileParseUpload = false;
              this.agentObj = null;
            });
    }

    private handleResubmit(results: RequestResult<any>[]) {          
      if (results.some(r => !r.Success)) {              
        let message = 'An error occurred resubmitting the uploaded data. Please contact support.';
        alert(message, 'Error');
      }        

      this.hidingEdit();
    }

    private handleSaveError(result: RequestResult) {            
        let message = 'An unknown error has occurred. Please contact support';
        // 1 for errors in saving agent data
        if (result.Data == 1) {
            message = 'An error occurred while saving the agent data. Please try submitting it again.';
        }
        // 2 for errors in resubmitting file parse upload ids
        else if (result.Data == 2) {
            message = 'An error while resubmitting upload data. Please view the Submitted Files table to resubmit the upload manually or contact support.';
        }

        alert(message, 'Error');
    }

    saveClientAgentData() : Promise<Guid[]> {
        //Creating a new client-agent or creating a new agent
        let result = this.clientAgentInfo.Agent.AgentId == this.emptyGuid || this.clientAgentInfo.ClientAgentId == 0
            ? this.clientAgentService.createClientAgentData(this.clientAgentInfo)
            : this.updateClientAgentData();
        
        this.agentObj = _.cloneDeep(this.clientAgentInfo);                

        return result;
    }

    private async updateClientAgentData() {
        let clientId = this.clientAgentInfo.Client.ClientId;
        var ids = await this.clientAgentService.updateClientAgentData(this.clientAgentInfo);            
        return ids;
    }

    resubmitFileParseUpload(fileUploadId: Guid) : Promise<RequestResult> {            
        return this.client.sendRequest(HttpMethodEnum.Patch, `/api/FileParseUploads/${fileUploadId}`);
    }

    getUnsetCountries(setCountryCodes: string[], result: CountryDto[]) : CountryDto[] {           
        let uniqueUnset = _.uniqBy(this.origUnsetCountries.concat(result), c => c.CountryCode);
        return uniqueUnset
            .filter(c => !setCountryCodes.includes(c.CountryCode))
            .sort((c1, c2) => c1.CountryCode < c2.CountryCode ? -1 : c1.CountryCode > c2.CountryCode ? 1 : 0);
    }

    onPopupHidden(e:any){
        this.mainEmailSource = [''];
        this.selectedMainEmail = [];
        this.emailCCSource = [''];
        this.selectedEmailCC = [];
    }        
}
